import React from 'react';
import '../template-file-css/document-file-template.css';


export const EDU_UniversalNote = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='EDU_UniversalNote' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'>
                    <span className='eleHeader'>Universal Note:</span>
                    <textarea id='txtUniversalNote' name='txtUniversalNote' className='add-only'></textarea>
                </p>




            </div>
        </form>

    )
}